import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FiArrowLeft } from "@react-icons/all-files/fi/FiArrowLeft";
import QrCode from "components/QrCode/QrCode";
function QrView({ qrUrl, onBack }) {
    return (_jsxs("div", { className: "share-modal__qr-view", children: [_jsxs("button", { type: "button", onClick: onBack, className: "share-modal__back", children: [_jsx(FiArrowLeft, {}), "Back"] }), _jsx(QrCode, { qrUrl: qrUrl })] }));
}
export default QrView;
